export const GRAPHQL_ROUTE = '/protected/1133177/graphql';
export const PAYMENT_NONCE_ROUTE =
  '/protected/1090382/dining-portal/payment/nonce';
export const SESSION_LOGOUT_ROUTE =
  '/protected/1090382/dining-portal/session/logout';
export const SESSION_TOKEN_ROUTE =
  '/protected/1090382/dining-portal/session/token';
export const MAINTENANCE_ROUTE = '/protected/1090382/dining-portal/maintenance';
